import React from 'react';
import {
  array, func, object, string, number,
} from 'prop-types';
import useLocale from '@active/react-utils/i18n/useLocale';
import isNil from 'lodash/isNil';
import OrderDetailContent from '../../../OrderDetailContent';
import PaymentResultInstallment from '../PaymentResultInstallment';
import PaymentResultSwitch from '../PaymentResultSwitch';
import OrderNumberAgencyName from '../OrderNumberAgencyName';
import PaymentDetailsContent from '../PaymentDetailsContent';

const PaymentResultDetail = ({
  orderPaymentResultList, toggleDetail, trackingCallback, confirmationMsg,
  totalAmount, currencyCode, locale, orderDescription,
  businessDate, orderReviewModel, confirmationMsgsForAgencies,
}) => {
  const { i18n } = useLocale();
  if (orderPaymentResultList.length === 0) {
    return null;
  }
  return (
    <React.Fragment>
      <PaymentResultSwitch
        title={'checkout.lib.components.paymentResult.detail.title'}
        switchText={'checkout.lib.components.paymentResult.detail.switch'}
        toggleDetail={toggleDetail}
        i18n={i18n}
        totalAmount={totalAmount}
        currencyCode={currencyCode}
        locale={locale}
        businessDate={businessDate}
        orderDescription={orderDescription}/>
      <div className='payment-result__details' >
        {
          orderPaymentResultList.map(({
            order: { orderNumber }, order, paymentResultList = [], shippingAddress,
            agency: { id, name } = {}, agency = {}, installments = [], billingSchedule,
          }) => (
            <div className="payment-result__detail" key={orderNumber}>
              {order && <React.Fragment>
                <OrderNumberAgencyName
                  orderReviewModel={orderReviewModel}
                  orderNumber={orderNumber}
                  agencyName={name}/>
                <OrderDetailContent
                  {...order}
                  orderReviewModel={orderReviewModel}
                  isShowVatAmount={true}
                  trackingCallback={trackingCallback}/>
              </React.Fragment>
              }
              { (paymentResultList.length > 0 || installments.length > 0) && <div className="hr-solid-line" />}
              <PaymentResultInstallment installments={installments} billingSchedule={billingSchedule}/>
              <PaymentDetailsContent
                paymentResultList={paymentResultList}
                installments={installments}
                agency={agency}
                shippingAddress={shippingAddress}
                confirmationMsg={isNil(confirmationMsgsForAgencies)
                  ? confirmationMsg
                  : confirmationMsgsForAgencies[id]}/>
            </div>
          ))
        }
      </div>
    </React.Fragment>
  );
};

PaymentResultDetail.propTypes = {
  orderPaymentResultList: array,
  toggleDetail: func.isRequired,
  confirmationMsg: string,
  trackingCallback: func,
  totalAmount: number,
  currencyCode: string,
  locale: string,
  orderDescription: string,
  businessDate: object,
  orderReviewModel: string,
};

PaymentResultDetail.defaultProps = {
  orderPaymentResultList: [],
};

export default PaymentResultDetail;
